import { Modal } from "antd";
import React, { useState, useEffect } from "react";

function TutorialModal({
  tutorialModalFlag,
  setTutorialModalFlag,
  setConcludeDemo,
}) {
  const [iframeSrc, setIframeSrc] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [timeLeft, setTimeLeft] = useState(15);

  useEffect(() => {
    if (tutorialModalFlag) {
      // Try direct iframe approach as fallback
      setIframeSrc("https://app.storylane.io/demo/dlsp6vtzmcdx?embed=inline");

      // Also try to load Storylane script
      const scriptId = "storylane-script";
      if (!document.getElementById(scriptId)) {
        const script = document.createElement("script");
        script.src = "https://js.storylane.io/js/v2/storylane.js";
        script.async = true;
        script.id = scriptId;

        script.onload = () => {
        //   console.log("Storylane script loaded");
          // Try to initialize after script loads
          setTimeout(() => {
            try {
              if (window.Storylane) {
                // console.log("Attempting Storylane init with container");
                window.Storylane.Play({
                  type: "inline",
                  demo_type: "image",
                  width: 2560,
                  height: 1215,
                  scale: "0.95",
                  demo_url:
                    "https://app.storylane.io/demo/dlsp6vtzmcdx?embed=inline",
                  padding_bottom: "calc(47.46% + 25px)",
                  container: "#storylane-container",
                });
              }

              return () => clearInterval(interval);
            } catch (e) {
              console.error("Storylane init error:", e);
            }
          }, 1000);
        };

        script.onerror = (e) => {
          console.error("Script load error:", e);
        };

        document.body.appendChild(script);
      } else {
        // Script already exists, try to initialize
        setTimeout(() => {
          try {
            if (window.Storylane) {
              window.Storylane.Play({
                type: "inline",
                demo_type: "image",
                width: 2560,
                height: 1215,
                scale: "0.95",
                demo_url:
                  "https://app.storylane.io/demo/dlsp6vtzmcdx?embed=inline",
                padding_bottom: "calc(47.46% + 25px)",
                container: "#storylane-container",
              });
            }
          } catch (e) {
            console.error("Storylane init error:", e);
          }
        }, 1000);
      }
      if (!disableButton) return;

      // Countdown interval
      const interval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setDisableButton(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [tutorialModalFlag]);

  const handleCancel = () => {
    setTutorialModalFlag(false);
    setIframeSrc("");
  };

  return (
    <Modal
      open={tutorialModalFlag}
      centered
      footer={null}
      closable={false}
      maskClosable={false}
      width={1000}
      destroyOnClose
      onCancel={handleCancel}
      title={
        <div className="flex items-center gap-3">
          <span className="flex p-[.6rem] rounded-lg shadow-sm border-[2px] border-[#E4E7EC]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 21V16M3.5 6V1M1 3.5H6M1 18.5H6M12 2L10.2658 6.50886C9.98381 7.24209 9.84281 7.60871 9.62353 7.91709C9.42919 8.1904 9.1904 8.42919 8.91709 8.62353C8.60871 8.8428 8.24209 8.98381 7.50886 9.26582L3 11L7.50886 12.7342C8.24209 13.0162 8.60871 13.1572 8.91709 13.3765C9.1904 13.5708 9.42919 13.8096 9.62353 14.0829C9.84281 14.3913 9.98381 14.7579 10.2658 15.4911L12 20L13.7342 15.4911C14.0162 14.7579 14.1572 14.3913 14.3765 14.0829C14.5708 13.8096 14.8096 13.5708 15.0829 13.3765C15.3913 13.1572 15.7579 13.0162 16.4911 12.7342L21 11L16.4911 9.26582C15.7579 8.98381 15.3913 8.8428 15.0829 8.62353C14.8096 8.42919 14.5708 8.1904 14.3765 7.91709C14.1572 7.60871 14.0162 7.24209 13.7342 6.50886L12 2Z"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <div>
            <p className="text-[#101828] font-semibold text-[1.12rem]">
              Guided Interview Walkthrough
            </p>
            <p className="text-gray-500 text-[.86rem] font-normal">
              Experience how the AI interview works before you begin.
            </p>
          </div>
        </div>
      }
      styles={{ body: { padding: 0 } }}
    >
      {/* Try both approaches - iframe as fallback */}
      <div style={{ position: "relative", width: "100%", minHeight: "495px" }}>
        {/* Storylane container */}
        <div
          id="storylane-container"
          style={{
            width: "100%",
            height: "100%",
            border: "2px solid red", // Visible border to confirm container exists
            position: "relative",
            zIndex: 1,
          }}
        />

        {/* Fallback iframe - visible if Storylane fails */}
        {iframeSrc && (
          <iframe
            src={iframeSrc}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "495px",
              //   border: "2px solid blue", // Visible border to confirm iframe loads
              zIndex: 2,
              background: "white",
            }}
            title="Storylane Demo"
            allow="fullscreen"
          />
        )}
      </div>
      <div className="mt-4 flex gap-x-6 gap-y-2 items-start">
        <span className="text-red-500 sm:w-1/2 w-full">
          Note: Please try the interactive demo to familiarize yourself with the
          platform and get started.
        </span>
        <button
          disabled={disableButton}
          onClick={() => {
            setTutorialModalFlag(false);
            setConcludeDemo(true);
          }}
          className={` ${disableButton ? "btn-disabled" : "btn-blue"} py-3 rounded-lg sm:w-1/2 w-full`}
        >
          Conclude & Finish{" "}
          {timeLeft > 0 && <span className="text-gray-600">({timeLeft})</span>}
        </button>
      </div>
    </Modal>
  );
}

export default TutorialModal;
